import { AppService } from './../../../../../core/app.service';
import { Component } from '@angular/core';
import { ActivtieResponse } from '../../../../../data/http/responses/activite.response';
import { MatIcon } from '@angular/material/icon';
import { FormArray, FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { LoaderComponent } from '../../../../../components/ui/loader/loader.component';
import { Input } from '../../../../../components/forms/input/input';
import { routeAlias } from '../../../../../../routesalias';
import { SelectOption } from '../../../../../data/schemas/selectoption.schema';
import { ActivatedRoute, Router } from '@angular/router';
import { ActiviteService } from '../../../../../services/activite/activite.service';
import { LigneBudgetaireService } from '../../../../../services/lignebudgetaire/lignebudgetaire.service';
import { ExpressionBesoinService } from '../../../../../services/expressionbesoin.service';
import { StructureService } from '../../../../../services/StructureService';
import { StructureResponse } from '../../../../../data/http/responses/strcuture.res';
import { LigneBudgetaireResponse } from '../../../../../data/http/responses/lignebudgetaire.res';
import { toCamelCase, toSnakeCaseUpper } from '../../../../../utils/helpers';
import { ExpressionBesoinReq } from '../../../../../data/http/requests/expression.req';
import { SelectComponent } from '../../../../../components/forms/select/select.component';

@Component({
  selector: 'app-edit',
  imports: [MatIcon, ReactiveFormsModule, LoaderComponent, Input, SelectComponent],
  templateUrl: './edit.component.html',
  styleUrl: './edit.component.css'
})
export class EditRegroupementExpressionBesoinPage {
  expressionBesoinForm!: FormGroup;
  public routesAlias = routeAlias;
  public expressionBesoinId: string | null = ""
  public expressionBesoinData: any = ""
  activities: ActivtieResponse[] = [];
  public isLoading: boolean = false;
  public structureData: SelectOption[] = []
  public ligneBudgetaires: SelectOption[] = []

  constructor(
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private activiteService: ActiviteService,
    private AppService: AppService,
    private ligneBudgetaireService: LigneBudgetaireService,
    private expressionBesoinService: ExpressionBesoinService,
    private structureService: StructureService
  ) { }

  ngOnInit(): void {
    this.expressionBesoinId = this.route.snapshot.paramMap.get('id');
    //this.loadTypeModePassation()
    this.expressionBesoinForm = this.fb.group({
      activitesSelectionnees: this.fb.array([]),
      applicationId: this.AppService.getAppId()!,

      complementaryInfo: this.fb.group({
        libelle: [''],
        description: [''],
        supervisor: [''],
        structureResponsable: [''],
        montantEstimatif: [''],
        imputationBudgetaire: [''],
        coutPrevuN1: [''],
        previsionDecaissementN2: [''],
        datePrevision: [''],
        dureePrevisionExecutionMarche: [''],
      })
    });

    if (this.expressionBesoinId) {
      this.loadExpressionBesoinById(this.expressionBesoinId);
    } else {
      console.error('Aucun ID d\'activité trouvé dans l\'URL.');
    }

    this.activitesFormArray.valueChanges.subscribe(selectedActivityIds => {
      this.updateCommonValues(selectedActivityIds);
    });

    //this.loadActivities();
    this.loadActivitiesAndExpressionBesoins();
    this.loadLigneBudgetaire();
    this.loadStructures()
  }

  // Getter pratique pour accéder facilement au FormArray depuis le template
  get activitesFormArray(): FormArray {
    return this.expressionBesoinForm.get('activitesSelectionnees') as FormArray;
  }

  // Getter pour le FormGroup des informations complémentaires
  get complementaryInfoFormGroup(): FormGroup {
    return this.expressionBesoinForm.get('complementaryInfo') as FormGroup;
  }

  // Ajoute un nouveau champ de sélection d'activité
  addActivity(): void {
    this.activitesFormArray.push(this.fb.control('', Validators.required));
  }

  // Supprime un champ de sélection d'activité à un index donné
  removeActivity(index: number): void {
    // Empêche la suppression du dernier élément
    if (this.activitesFormArray.length > 1) {
      this.activitesFormArray.removeAt(index);
    }
  }

  /* loadActivities() : void{
    this.activiteService.getAllByAppId(this.cookiesService.getCookie("appid")!).subscribe({
      next: (response) =>{
        this.activities = response.data as ActivtieResponse[];
        //console.log("Activities loaded:", this.activities);
      },
      error: (error) =>{
        console.error("Erreur lors du chargement des activités", error);
      }
    })
  } */

  /* loadExpressionBesoins(): void {
    this.expressionBesoinService.getAllByAppIdExcludeRegroupement(this.cookiesService.getCookie("appid")!).subscribe({
      next: (response: any) => {
        //console.log(response.data)
        this.activities = response.data;
      },
      error: (error) => {
        console.error('Erreur lors du chargement des structures :', error);
      }
    });
  } */

  loadActivitiesAndExpressionBesoins(): void {
    // Charger les activités classiques
    /* this.activiteService.getAllByAppId(this.cookiesService.getCookie("appid")!).subscribe({
      next: (response1) => {
        const activitiesList = response1.data as ActivtieResponse[];
 
        
      },
      error: (error) => {
        console.error("Erreur lors du chargement des activités", error);
      }
    }); */
    // Charger les regroupements/expression besoins
    this.expressionBesoinService.getAllByAppId(this.AppService.getAppId()!).subscribe({
      next: (response2: any) => {
        const expressionList = response2.data as ActivtieResponse[];

        // Fusionner les deux tableaux
        this.activities = [...expressionList];
        //console.log("Toutes les activités fusionnées :", this.activities);
      },
      error: (error) => {
        console.error('Erreur lors du chargement des regroupements :', error);
        // Si erreur, garder seulement activitiesList
        this.activities = [...[]];
      }
    });
  }

  loadStructures(): void {
    this.structureService.getAllByAppId(this.AppService.getAppId()!).subscribe({
      next: (response: any) => {
        this.structureData = response.data.map((item: StructureResponse) => ({
          value: item.code, // Assurez-vous que c'est bien l'ID (ou le code) qui est la valeur
          label: item?.code
        }));
      },
      error: (error) => {
        console.error('Erreur lors du chargement des structures :', error);
      }
    });
  }

  loadLigneBudgetaire(): void {
    this.ligneBudgetaireService.getAllByAppId(this.AppService.getAppId()!).subscribe({
      next: (response: any) => {
        this.ligneBudgetaires = response.data.map((item: LigneBudgetaireResponse) => ({
          value: item.libelle, // Assurez-vous que c'est bien l'ID (ou le code) qui est la valeur
          label: item?.libelle
        }));;
      },
      error: (error) => {
        console.error('Erreur lors du chargement des structures :', error);
      }
    });
  }

  loadExpressionBesoinById(id: string): void {
    this.expressionBesoinService.getById(id).subscribe({
      next: (response: any) => {
        //console.log("Données reçues pour l'édition :", response.data)
        this.expressionBesoinData = response.data; // Stockez la réponse complète si nécessaire
        // --- 1. Gestion du FormArray pour les activités ---
        // Vider le FormArray existant pour éviter les doublons
        this.activitesFormArray.clear();

        // Remplir le FormArray avec les activités de la réponse
        if (response.data.regroupements && Array.isArray(response.data.regroupements)) {
          response.data.regroupements.forEach((activityId: any) => {
            this.activitesFormArray.push(this.fb.control(activityId.id, Validators.required));
          });
        }

        const patchData = {
          activitesSelectionnees: this.activitesFormArray.value,
          complementaryInfo: {
            libelle: response.data.titre,
            description: response.data.objectif,
          }
        };

        // --- 3. Mapping des caractéristiques vers le FormGroup 'complementaryInfo' ---
        response.data.caracteristiques.forEach((detail: any) => {
          // Convertir le code SNAKE_CASE en camelCase pour correspondre au nom du FormControl
          const formControlName = toCamelCase(detail.code);

          // Ajouter la valeur au bon endroit dans l'objet patchData
          (patchData.complementaryInfo as any)[formControlName] = detail.valeur;
        });

        //console.log("Objet préparé pour patchValue:", patchData);

        // --- 4. Appliquer les valeurs au formulaire ---
        this.expressionBesoinForm.patchValue(patchData);
      },
      error: (error) => {
        console.error('Erreur lors du chargement de l\'activité par ID :', error);
      }
    })
  }

  // Méthode pour mettre à jour les valeurs communes
  updateCommonValues(selectedActivityIds: string[]): void {
    if (!selectedActivityIds || selectedActivityIds.length === 0) {
      this.resetComplementaryInfo();
      return;
    }

    // Filtrer les activités sélectionnées
    const selectedActivities = this.activities.filter(activity =>
      selectedActivityIds.includes(activity.id!)
    );

    if (selectedActivities.length === 0) return;

    // Récupérer les valeurs communes
    const commonValues = this.getCommonCharacteristics(selectedActivities);

    // Mettre à jour le formulaire avec les valeurs communes
    this.updateFormWithCommonValues(commonValues);
  }

  // Méthode pour obtenir les caractéristiques communes
  getCommonCharacteristics(activities: ActivtieResponse[]): any {
    const commonValues: any = {
      supervisor: null,
      structureResponsable: null,
      imputationBudgetaire: null
    };

    if (activities.length === 0) return commonValues;

    // Vérifier SUPERVISOR
    const supervisors = activities.map(activity =>
      this.getCharacteristicValue(activity, 'SUPERVISOR')
    );
    if (this.allValuesEqual(supervisors)) {
      commonValues.supervisor = supervisors[0];
    } else {
      commonValues.supervisor = ''; // Explicitement vide si pas commun
    }

    // Vérifier STRUCTURE_RESPONSABLE
    const structures = activities.map(activity =>
      this.getCharacteristicValue(activity, 'STRUCTURE_RESPONSABLE')
    );
    if (this.allValuesEqual(structures)) {
      commonValues.structureResponsable = structures[0];
    } else {
      commonValues.structureResponsable = ''; // Explicitement vide si pas commun
    }

    // Vérifier IMPUTATION_BUDGETAIRE
    const imputations = activities.map(activity =>
      this.getCharacteristicValue(activity, 'IMPUTATION_BUDGETAIRE')
    );
    if (this.allValuesEqual(imputations)) {
      commonValues.imputationBudgetaire = imputations[0];
    } else {
      commonValues.imputationBudgetaire = ''; // Explicitement vide si pas commun
    }
    //console.log(commonValues)

    return commonValues;
  }

  // Méthode utilitaire pour récupérer une valeur de caractéristique
  getCharacteristicValue(activity: ActivtieResponse, code: string): string {
    const caracteristique = activity.caracteristiques?.find(c => c.code === code);
    return caracteristique ? caracteristique.valeur : '';
  }

  // Méthode pour vérifier si toutes les valeurs d'un tableau sont égales
  allValuesEqual(values: string[]): boolean {
    if (values.length === 0) return false;

    // Filtrer les valeurs vides
    const nonEmptyValues = values.filter(value => value && value.trim() !== '');
    if (nonEmptyValues.length === 0) return false;

    const firstValue = nonEmptyValues[0];
    return nonEmptyValues.every(value => value === firstValue);
  }

  // Mettre à jour le formulaire avec les valeurs communes
  updateFormWithCommonValues(commonValues: any): void {
    const complementaryInfo = this.complementaryInfoFormGroup;

    // Pour chaque champ, mettre à jour seulement si non modifié manuellement
    const fields = ['supervisor', 'structureResponsable', 'imputationBudgetaire'];

    fields.forEach(field => {
      const control = complementaryInfo.get(field);
      if (control && !control.dirty) {
        control.setValue(commonValues[field] || '');
      }
    });
  }

  // Réinitialiser les informations complémentaires
  resetComplementaryInfo(): void {
    const resetValues = {
      supervisor: '',
      structureResponsable: '',
      imputationBudgetaire: ''
    };

    this.complementaryInfoFormGroup.patchValue(resetValues);

    // Réinitialiser l'état "dirty" pour permettre les mises à jour futures
    this.complementaryInfoFormGroup.markAsPristine();
  }

  onSubmit(): void {
    if (this.expressionBesoinForm.valid) {

      const caracteristiquesArray: { code: string; valeur: any }[] = [];

      const excludedFieldForComplementaryInfo = ['libelle', 'description'];
      Object.keys(this.expressionBesoinForm.value.complementaryInfo).forEach(key => {
        // Exclure les champs spécifiés
        if (!excludedFieldForComplementaryInfo.includes(key)) {
          caracteristiquesArray.push({
            code: toSnakeCaseUpper(key),
            valeur: this.expressionBesoinForm.value.complementaryInfo[key] ?? ""
          });
        }
      });

      this.isLoading = true
      let requestBody: ExpressionBesoinReq = {
        applicationId: this.expressionBesoinForm.value.applicationId,
        activites: this.expressionBesoinForm.value.activitesSelectionnees,
        typeActivite: "MARCHE",
        titre: this.expressionBesoinForm.value.complementaryInfo.libelle,
        objectif: this.expressionBesoinForm.value.complementaryInfo.description,
        caracteristiques: caracteristiquesArray
      }
      //console.log(requestBody)

      this.expressionBesoinService.update(this.expressionBesoinId!, requestBody).subscribe({
        next: () => {
          this.isLoading = false;
          this.router.navigate([
            routeAlias.marches.home,
            routeAlias.marches.expression_besoin.home,
          ]);
        },
        error: (error) => {
          console.error('Erreur lors de la mise à jour de la ligne budgétaire :', error);
          this.isLoading = false;
        }
      });
      // Ici, vous pouvez envoyer les données au service
    } else {
      console.error('Le formulaire est invalide');
      this.expressionBesoinForm.markAllAsTouched(); // Affiche les erreurs de validation
    }
  }
}
